import { render, staticRenderFns } from "./create.vue?vue&type=template&id=51ccf0e3&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccf0e3",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CButton: require('@chakra-ui/vue').CButton, CStack: require('@chakra-ui/vue').CStack, CBox: require('@chakra-ui/vue').CBox})
